import React, {FunctionComponent, useEffect, useMemo, useState} from 'react';
import {affiliateEngine, headlessEngine} from '../../../engine/engine';
import {pillId} from '../../../utils/utils';
import {Checkbox} from '../Facet/FacetType/Checkbox';
import {DateFacet} from '../Facet/FacetType/DateRange';
import {DateFacet2} from '../Facet/FacetType/DateRange2';
import CheckboxPrice from '../Facet/FacetType/PriceRange';
// import {CheckboxPriceAffilliate} from '../Facet/FacetType/PriceRangeAffilliate';
import './scss/Facet.scss';
import {AEMPriceRange, facetCustomerType, filterEndDate, filterStartDate, facetFileLanguage, facetFileType} from '../../../controllers/facetControllers';
import {CheckboxRecommended} from "./FacetType/CheckboxRecommended";

interface FacetProps {
    controller: any;
    type?: number;
    pillProSelected?: any;
    pillConsumerSelected: any;
    pillBusinessSelected?: any;
    initFacet?: string;
    isAffiliate?: boolean;
    isFirstLoad?: boolean;
    isShowRecommendedForModel?: any;
    isActiveINET?: boolean;
}

export const Facet: FunctionComponent<FacetProps> = (props) => {

    const {type, isAffiliate} = props;
    const [show, setShow] = useState(false);

    let numberFacet = 0;
    let facetProductArrays = [
        {
            facet: props.controller.facetBrightnessProduct,
            render: <Checkbox key="mainStore-facetBrightnessProduct" title="Brightness"
                              controller={props.controller.facetBrightnessProduct}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetProjectorlenstypes,
            render: <Checkbox key="mainStore-facetProjectorlenstypes" title="Projector Lens Types"
                              controller={props.controller.facetProjectorlenstypes}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetProjectorslightsource,
            render: <Checkbox key="mainStore-facetProjectorslightsource" title="Light Source"
                              controller={props.controller.facetProjectorslightsource}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetProjectorProductFamily,
            render: <Checkbox key="mainStore-facetProjectorProductFamily" title="Projector Product Family"
                              controller={props.controller.facetProjectorProductFamily}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetProjectionTechnology,
            render: <Checkbox key="mainStore-facetProjectionTechnology" title="Projection Technology"
                              controller={props.controller.facetProjectionTechnology}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPixelPitch,
            render: <Checkbox key="mainStore-facetPixelPitch" title="Pixel Pitch"
                              controller={props.controller.facetPixelPitch}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetSecurityCameraType,
            render: <Checkbox key="mainStore-facetSecurityCameraType" title="Security Camera Type"
                              controller={props.controller.facetSecurityCameraType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOutdoorReady,
            render: <Checkbox key="mainStore-facetOutdoorReady" title="Outdoor Ready"
                              controller={props.controller.facetOutdoorReady}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVandalResistant,
            render: <Checkbox key="mainStore-facetVandalResistant" title="Vandal Resistant"
                              controller={props.controller.facetVandalResistant}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetApproximateMonthlyVolume,
            render: <Checkbox key="mainStore-facetApproximateMonthlyVolume" title="Approximate Monthly Volume"
                              controller={props.controller.facetApproximateMonthlyVolume}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOfficeFeatures,
            render: <Checkbox key="mainStore-facetOfficeFeatures" title="Office Features"
                              controller={props.controller.facetOfficeFeatures}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetFlatbedIncluded,
            render: <Checkbox key="mainStore-facetFlatbedIncluded" title="Flatbed Included"
                              controller={props.controller.facetFlatbedIncluded}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMaximumPaperCapacity,
            render: <Checkbox key="mainStore-facetMaximumPaperCapacity" title="Maximum Paper Capacity"
                              controller={props.controller.facetMaximumPaperCapacity}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOfficeMaximumPaperSize,
            render: <Checkbox key="mainStore-facetOfficeMaximumPaperSize" title="Office Maximum Paper Size"
                              controller={props.controller.facetOfficeMaximumPaperSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOutputType,
            render: <Checkbox key="mainStore-facetOutputType" title="Output Type"
                              controller={props.controller.facetOutputType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrintCapability,
            render: <Checkbox key="mainStore-facetPrintCapability" title="Print Capability"
                              controller={props.controller.facetPrintCapability}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrintSpeed,
            render: <Checkbox key="mainStore-facetPrintSpeed" title="Print Speed"
                              controller={props.controller.facetPrintSpeed}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOfficeProductFamily,
            render: <Checkbox key="mainStore-facetOfficeProductFamily" title="Office Product Family"
                              controller={props.controller.facetOfficeProductFamily}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetScannerType,
            render: <Checkbox key="mainStore-facetScannerType" title="Scanner Type"
                              controller={props.controller.facetScannerType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetSendCapability,
            render: <Checkbox key="mainStore-facetSendCapability" title="Send Capability"
                              controller={props.controller.facetSendCapability}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetColors,
            render: <Checkbox key="mainStore-facetColors" title="Colors" controller={props.controller.facetColors}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraExperienceLevel,
            render: <Checkbox key="mainStore-facetCameraExperienceLevel" title="Camera Experience Level"
                              controller={props.controller.facetCameraExperienceLevel}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraFeatures,
            render: <Checkbox key="mainStore-facetCameraFeatures" title="Camera Features"
                              controller={props.controller.facetCameraFeatures}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetGuideNO,
            render: <Checkbox key="mainStore-facetGuideNO" title="Guide NO." controller={props.controller.facetGuideNO}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMaximumISO,
            render: <Checkbox key="mainStore-facetMaximumISO" title="Maximum ISO"
                              controller={props.controller.facetMaximumISO}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetmegapixels,
            render: <Checkbox key="mainStore-facetmegapixels" title="Megapixels"
                              controller={props.controller.facetmegapixels}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOpticalZoom,
            render: <Checkbox key="mainStore-facetOpticalZoom" title="Optical Zoom"
                              controller={props.controller.facetOpticalZoom}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraProductSeries,
            render: <Checkbox key="mainStore-facetCameraProductSeries" title="Camera Product Series"
                              controller={props.controller.facetCameraProductSeries}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetImageProcessor,
            render: <Checkbox key="mainStore-facetImageProcessor" title="Image Processor"
                              controller={props.controller.facetImageProcessor}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoProductFamily,
            render: <Checkbox key="mainStore-facetVideoProductFamily" title="Video Product Family"
                              controller={props.controller.facetVideoProductFamily}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensCameraType,
            render: <Checkbox key="mainStore-facetLensCameraType" title="Lens Camera Type"
                              controller={props.controller.facetLensCameraType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensExperienceLevel,
            render: <Checkbox key="mainStore-facetLensExperienceLevel" title="Lens Experience Level"
                              controller={props.controller.facetLensExperienceLevel}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensByUsage,
            render: <Checkbox key="mainStore-facetLensByUsage" title="Lens By Usage"
                              controller={props.controller.facetLensByUsage}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensTypes,
            render: <Checkbox key="mainStore-facetLensTypes" title="Lens Types"
                              controller={props.controller.facetLensTypes}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMount,
            render: <Checkbox key="mainStore-facetMount" title="Mount" controller={props.controller.facetMount}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensProductSeries,
            render: <Checkbox key="mainStore-facetLensProductSeries" title="Lens Product Series"
                              controller={props.controller.facetLensProductSeries}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetZoomFixedFocalLength,
            render: <Checkbox key="mainStore-facetZoomFixedFocalLength" title="Zoom/Fixed Focal Length"
                              controller={props.controller.facetZoomFixedFocalLength}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensFeatures,
            render: <Checkbox key="mainStore-facetLensFeatures" title="Lens Features"
                              controller={props.controller.facetLensFeatures}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMagnification,
            render: <Checkbox key="mainStore-facetMagnification" title="Magnification (X)"
                              controller={props.controller.facetMagnification}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetObjectiveLensDiameter,
            render: <Checkbox key="mainStore-facetObjectiveLensDiameter" title="Objective Lens Diameter (MM)"
                              controller={props.controller.facetObjectiveLensDiameter}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetGrade,
            render: <Checkbox key="mainStore-facetGrade" title="Grade" controller={props.controller.facetGrade}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraVideoResolution,
            render: <Checkbox key="mainStore-facetCameraVideoResolution" title="Camera Video Resolution"
                              controller={props.controller.facetCameraVideoResolution}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraSensorSize,
            render: <Checkbox key="mainStore-facetCameraSensorSize" title="Camera Sensor Size"
                              controller={props.controller.facetCameraSensorSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraLensMount,
            render: <Checkbox key="mainStore-facetCameraLensMount" title="Camera Lens Mount"
                              controller={props.controller.facetCameraLensMount}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraFrameRate,
            render: <Checkbox key="mainStore-facetCameraFrameRate" title="Camera Frame Rate"
                              controller={props.controller.facetCameraFrameRate}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraRecordingFormat,
            render: <Checkbox key="mainStore-facetCameraRecordingFormat" title="Camera Recording Format"
                              controller={props.controller.facetCameraRecordingFormat}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraSpecialRecording,
            render: <Checkbox key="mainStore-facetCameraSpecialRecording" title="Camera Special Recording"
                              controller={props.controller.facetCameraSpecialRecording}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraConnectivity,
            render: <Checkbox key="mainStore-facetCameraConnectivity" title="Camera Connectivity"
                              controller={props.controller.facetCameraConnectivity}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraAudio,
            render: <Checkbox key="mainStore-facetCameraAudio" title="Camera Audio"
                              controller={props.controller.facetCameraAudio}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraVideoOutput,
            render: <Checkbox key="mainStore-facetCameraVideoOutput" title="Camera Video Output"
                              controller={props.controller.facetCameraVideoOutput}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCameraRecordingMedia,
            render: <Checkbox key="mainStore-facetCameraRecordingMedia" title="Camera Recording Media"
                              controller={props.controller.facetCameraRecordingMedia}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetBestfor,
            render: <Checkbox key="mainStore-facetBestfor" title="Best for" controller={props.controller.facetBestfor}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensType,
            render: <Checkbox key="mainStore-facetLensType" title="Lens Type"
                              controller={props.controller.facetLensType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensMount,
            render: <Checkbox key="mainStore-facetLensMount" title="Lens Mount"
                              controller={props.controller.facetLensMount}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetSensorCoverage,
            render: <Checkbox key="mainStore-facetSensorCoverage" title="Sensor Coverage"
                              controller={props.controller.facetSensorCoverage}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLensZoomRange,
            render: <Checkbox key="mainStore-facetLensZoomRange" title="Lens Zoom Range"
                              controller={props.controller.facetLensZoomRange}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetIrisBlades,
            render: <Checkbox key="mainStore-facetIrisBlades" title="Iris Blades"
                              controller={props.controller.facetIrisBlades}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMaximumAperture,
            render: <Checkbox key="mainStore-facetMaximumAperture" title="Maximum Aperture"
                              controller={props.controller.facetMaximumAperture}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetFixedFocalLength,
            render: <Checkbox key="mainStore-facetFixedFocalLength" title="Fixed Focal Length"
                              controller={props.controller.facetFixedFocalLength}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetNativeImageCircle,
            render: <Checkbox key="mainStore-facetNativeImageCircle" title="Native Image Circle"
                              controller={props.controller.facetNativeImageCircle}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMotorFunction,
            render: <Checkbox key="mainStore-facetMotorFunction" title="Motor Function"
                              controller={props.controller.facetMotorFunction}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrinterFeatures,
            render: <Checkbox key="mainStore-facetPrinterFeatures" title="Printer Features"
                              controller={props.controller.facetPrinterFeatures}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMediaSize,
            render: <Checkbox key="mainStore-facetMediaSize" title="Media Size"
                              controller={props.controller.facetMediaSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMediaType,
            render: <Checkbox key="mainStore-facetMediaType" title="Media Type"
                              controller={props.controller.facetMediaType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrintersIndustry,
            render: <Checkbox key="mainStore-facetPrintersIndustry" title="Industry"
                              controller={props.controller.facetPrintersIndustry}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrinterFunctions,
            render: <Checkbox key="mainStore-facetPrinterFunctions" title="Printer Functions"
                              controller={props.controller.facetPrinterFunctions}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetColorBW,
            render: <Checkbox key="mainStore-facetColorBW" title="Color/B&W" controller={props.controller.facetColorBW}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetRecommendedMonthlyPageVolume,
            render: <Checkbox key="mainStore-facetRecommendedMonthlyPageVolume" title="Recommended Monthly Page Volume"
                              controller={props.controller.facetRecommendedMonthlyPageVolume}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrintSpeedimagespagesperminute,
            render: <Checkbox key="mainStore-facetPrintSpeedimagespagesperminute"
                              title="Print Speed (images/pages per minute)"
                              controller={props.controller.facetPrintSpeedimagespagesperminute}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrinterMaximumPaperSize,
            render: <Checkbox key="mainStore-facetPrinterMaximumPaperSize" title="Printer Maximum Paper Size"
                              controller={props.controller.facetPrinterMaximumPaperSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetStandardPaperCapacity,
            render: <Checkbox key="mainStore-facetStandardPaperCapacity" title="Standard Paper Capacity"
                              controller={props.controller.facetStandardPaperCapacity}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMaxPaperCapacityOption,
            render: <Checkbox key="mainStore-facetMaxPaperCapacityOption" title="Max Paper Capacity (with options)"
                              controller={props.controller.facetMaxPaperCapacityOption}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPurchaseOnlineFromCanon,
            render: <Checkbox key="mainStore-facetPurchaseOnlineFromCanon" title="Purchase Online From Canon"
                              controller={props.controller.facetPurchaseOnlineFromCanon}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrinterSeries,
            render: <Checkbox key="mainStore-facetPrinterSeries" title="Printer Series"
                              controller={props.controller.facetPrinterSeries}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetAvailableConnectivity,
            render: <Checkbox key="mainStore-facetAvailableConnectivity" title="Available Connectivity"
                              controller={props.controller.facetAvailableConnectivity}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetAutoTonerInkReplenishment,
            render: <Checkbox key="mainStore-facetAutoTonerInkReplenishment" title="Auto Toner/Ink Replenishment"
                              controller={props.controller.facetAutoTonerInkReplenishment}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrinterTechnology,
            render: <Checkbox key="mainStore-facetPrinterTechnology" title="Printer Technology"
                              controller={props.controller.facetPrinterTechnology}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetStandardWarranty,
            render: <Checkbox key="mainStore-facetStandardWarranty" title="Standard Warranty"
                              controller={props.controller.facetStandardWarranty}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetEnvironment,
            render: <Checkbox key="mainStore-facetEnvironment" title="Environment"
                              controller={props.controller.facetEnvironment}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetKeyFeaturesInkjet,
            render: <Checkbox key="mainStore-facetKeyFeaturesInkjet" title="Key Features (Inkjet)"
                              controller={props.controller.facetKeyFeaturesInkjet}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrinterColorInkjet,
            render: <Checkbox key="mainStore-facetPrinterColorInkjet" title="Printer Color (Inkjet)"
                              controller={props.controller.facetPrinterColorInkjet}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCompatiblePaperSizesInkjet,
            render: <Checkbox key="mainStore-facetCompatiblePaperSizesInkjet" title="Compatible Paper Sizes (Inkjet)"
                              controller={props.controller.facetCompatiblePaperSizesInkjet}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetTechnicalCADPrinters,
            render: <Checkbox key="mainStore-facetTechnicalCADPrinters" title="Technical CAD Printers"
                              controller={props.controller.facetTechnicalCADPrinters}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLargeFormatPrinterSeries,
            render: <Checkbox key="mainStore-facetLargeFormatPrinterSeries" title="Large Format Printer Series"
                              controller={props.controller.facetLargeFormatPrinterSeries}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLargeFormatPrinterTechnology,
            render: <Checkbox key="mainStore-facetLargeFormatPrinterTechnology" title="Large Format Printer Technology"
                              controller={props.controller.facetLargeFormatPrinterTechnology}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPrinterSpeed,
            render: <Checkbox key="mainStore-facetPrinterSpeed" title="Printer Speed"
                              controller={props.controller.facetPrinterSpeed}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMaxPaperWidth,
            render: <Checkbox key="mainStore-facetMaxPaperWidth" title="Max Paper Width"
                              controller={props.controller.facetMaxPaperWidth}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetNumberofrolls,
            render: <Checkbox key="mainStore-facetNumberofrolls" title="Number of rolls"
                              controller={props.controller.facetNumberofrolls}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOutputtypes,
            render: <Checkbox key="mainStore-facetOutputtypes" title="Output types"
                              controller={props.controller.facetOutputtypes}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetDocumentTypes,
            render: <Checkbox key="mainStore-facetDocumentTypes" title="Document Types"
                              controller={props.controller.facetDocumentTypes}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOptions,
            render: <Checkbox key="mainStore-facetOptions" title="Options" controller={props.controller.facetOptions}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetCommercialGraphics,
            render: <Checkbox key="mainStore-facetCommercialGraphics" title="Commercial Graphics"
                              controller={props.controller.facetCommercialGraphics}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMaxPrintSize,
            render: <Checkbox key="mainStore-facetMaxPrintSize" title="Max Print Size"
                              controller={props.controller.facetMaxPrintSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetInkColors,
            render: <Checkbox key="mainStore-facetInkColors" title="Ink Colors"
                              controller={props.controller.facetInkColors}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetSupportedRIPs,
            render: <Checkbox key="mainStore-facetSupportedRIPs" title="Supported RIP's"
                              controller={props.controller.facetSupportedRIPs}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMerchandiseType,
            render: <Checkbox key="mainStore-facetMerchandiseType" title="Type"
                              controller={props.controller.facetMerchandiseType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoSensorSize,
            render: <Checkbox key="mainStore-facetVideoSensorSize" title="Video Sensor Size"
                              controller={props.controller.facetVideoSensorSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideovideoResolution,
            render: <Checkbox key="mainStore-facetVideovideoResolution" title="Video Resolution"
                              controller={props.controller.facetVideovideoResolution}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoLensMount,
            render: <Checkbox key="mainStore-facetVideoLensMount" title="Video Lens Mount"
                              controller={props.controller.facetVideoLensMount}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoFrameRate,
            render: <Checkbox key="mainStore-facetVideoFrameRate" title="Video Frame Rate"
                              controller={props.controller.facetVideoFrameRate}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoRecordingFormat,
            render: <Checkbox key="mainStore-facetVideoRecordingFormat" title="Video Recording Format"
                              controller={props.controller.facetVideoRecordingFormat}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoSpecialRecording,
            render: <Checkbox key="mainStore-facetVideoSpecialRecording" title="Video Special Recording"
                              controller={props.controller.facetVideoSpecialRecording}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoConnectivity,
            render: <Checkbox key="mainStore-facetVideoConnectivity" title="Video Connectivity"
                              controller={props.controller.facetVideoConnectivity}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoAudio,
            render: <Checkbox key="mainStore-facetVideoAudio" title="Video Audio"
                              controller={props.controller.facetVideoAudio}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoOutput,
            render: <Checkbox key="mainStore-facetVideoOutput" title="Video Output"
                              controller={props.controller.facetVideoOutput}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoFeatures,
            render: <Checkbox key="mainStore-facetVideoFeatures" title="Video Features"
                              controller={props.controller.facetVideoFeatures}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoRecordingMedia,
            render: <Checkbox key="mainStore-facetVideoRecordingMedia" title="Video Recording Media"
                              controller={props.controller.facetVideoRecordingMedia}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMinimumAperture,
            render: <Checkbox key="mainStore-facetMinimumAperture" title="Minimum Aperture"
                              controller={props.controller.facetMinimumAperture}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetVideoZoomRange,
            render: <Checkbox key="mainStore-facetVideoZoomRange" title="Video Zoom Range"
                              controller={props.controller.facetVideoZoomRange}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetNativeResolution,
            render: <Checkbox key="mainStore-facetNativeResolution" title="Native Resolution"
                              controller={props.controller.facetNativeResolution}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetZoomRatio,
            render: <Checkbox key="mainStore-facetZoomRatio" title="Zoom Ratio"
                              controller={props.controller.facetZoomRatio}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetImageSize,
            render: <Checkbox key="mainStore-facetImageSize" title="Image Size"
                              controller={props.controller.facetImageSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetFocalLength,
            render: <Checkbox key="mainStore-facetFocalLength" title="Focal Length"
                              controller={props.controller.facetFocalLength}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetFNumber,
            render: <Checkbox key="mainStore-facetFNumber" title="F Number" controller={props.controller.facetFNumber}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetNativeContrastRatio,
            render: <Checkbox key="mainStore-facetNativeContrastRatio" title="Native Contrast Ratio"
                              controller={props.controller.facetNativeContrastRatio}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetInterfaces,
            render: <Checkbox key="mainStore-facetInterfaces" title="Interfaces"
                              controller={props.controller.facetInterfaces}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetWeight,
            render: <Checkbox key="mainStore-facetWeight" title="Weight" controller={props.controller.facetWeight}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMaximumResolution,
            render: <Checkbox key="mainStore-facetMaximumResolution" title="Maximum Resolution"
                              controller={props.controller.facetMaximumResolution}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetMinimumIlluminationColor,
            render: <Checkbox key="mainStore-facetMinimumIlluminationColor" title="Minimum Illumination (Color)"
                              controller={props.controller.facetMinimumIlluminationColor}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetOpticalZoomRange,
            render: <Checkbox key="mainStore-facetOpticalZoomRange" title="Optical Zoom Range"
                              controller={props.controller.facetOpticalZoomRange}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetPowerSupply,
            render: <Checkbox key="mainStore-facetPowerSupply" title="Power Supply"
                              controller={props.controller.facetPowerSupply}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetONVIFProfiles,
            render: <Checkbox key="mainStore-facetONVIFProfiles" title="ONVIF Profiles"
                              controller={props.controller.facetONVIFProfiles}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetFeederCapacity,
            render: <Checkbox key="mainStore-facetFeederCapacity" title="Feeder Capacity"
                              controller={props.controller.facetFeederCapacity}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetDailyScanVolume,
            render: <Checkbox key="mainStore-facetDailyScanVolume" title="Daily Scan Volume"
                              controller={props.controller.facetDailyScanVolume}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetWarrantyIncluded,
            render: <Checkbox key="mainStore-facetWarrantyIncluded" title="Warranty Included"
                              controller={props.controller.facetWarrantyIncluded}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetScannedPagesPerMinute,
            render: <Checkbox key="mainStore-facetScannedPagesPerMinute" title="Scanned Pages Per Minute"
                              controller={props.controller.facetScannedPagesPerMinute}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetInterface,
            render: <Checkbox key="mainStore-facetInterface" title="Interface"
                              controller={props.controller.facetInterface}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetADFMaxPageSize,
            render: <Checkbox key="mainStore-facetADFMaxPageSize" title="ADF Max Page Size"
                              controller={props.controller.facetADFMaxPageSize}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetEPEATRating,
            render: <Checkbox key="mainStore-facetEPEATRating" title="EPEAT Rating"
                              controller={props.controller.facetEPEATRating}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetImprinter,
            render: <Checkbox key="mainStore-facetImprinter" title="Imprinter"
                              controller={props.controller.facetImprinter}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
    ]

    let facetLearningArrays = [
        {
            facet: props.controller.facetTopic,
            render: <Checkbox key="Topic" title="Topic" controller={props.controller.facetTopic}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetSkillLevel,
            render: <Checkbox key="Skill Level" title="Skill Level" controller={props.controller.facetSkillLevel}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLocation,
            render: <Checkbox key="Location" title="Location" controller={props.controller.facetLocation}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetInstructor,
            render: <Checkbox key="Instructor" title="Instructor" controller={props.controller.facetInstructor}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetProductType,
            render: <Checkbox key="Product Type" title="Product Type" controller={props.controller.facetProductType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLength,
            render: <Checkbox key="Length" title="Length" controller={props.controller.facetLength}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetAuthor,
            render: <Checkbox key="Author" title="Author" controller={props.controller.facetAuthor}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetIndustry,
            render: <Checkbox key="Industry" title="Industry" controller={props.controller.facetIndustry}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        }
    ];
    let facetResourceArrays = [
        {
            facet: props.controller.facetTopic,
            render: <Checkbox title="Topic" controller={props.controller.facetTopic}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetSkillLevel,
            render: <Checkbox title="Skill Level" controller={props.controller.facetSkillLevel}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLocation,
            render: <Checkbox title="Location" controller={props.controller.facetLocation}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetInstructor,
            render: <Checkbox title="Instructor" controller={props.controller.facetInstructor}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetProductType,
            render: <Checkbox title="Product Type" controller={props.controller.facetProductType}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetLength,
            render: <Checkbox title="Length" controller={props.controller.facetLength}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        },
        {
            facet: props.controller.facetAuthor,
            render: <Checkbox title="Author" controller={props.controller.facetAuthor}
                              pillBusinessSelected={props.pillBusinessSelected}
                              pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected}
                              facetDeSelect={props.controller}/>
        }
    ]

    useMemo(() => {
        setTimeout(() => {
            accordionAllFacet();
        }, 500);
    }, [props])

    useEffect(() => {
        setShow(false);
    }, [type])
    useEffect(() => {
        accordionAllFacet();
    }, [show])

    function checkviewmore() {
        let numberFacetfunction = 0;
        if (type === pillId.PRODUCT) {
            facetProductArrays.map((facetProductArray: any) => {
                    if (facetProductArray.facet.state.values?.length > 0) {
                        numberFacetfunction++;
                    }
                    return numberFacetfunction;
                }
            )
        }
        if (type === pillId.LEARNING) {
            facetLearningArrays.map((facetLearningArray: any) => {
                    if (facetLearningArray.facet.state.values?.length > 0) {
                        numberFacetfunction++;
                    }
                    return numberFacetfunction;
                }
            )
        }
        if (type === pillId.RESOURCES) {
            facetResourceArrays.map((facetLearningArray: any) => {
                    if (facetLearningArray.facet.state.values?.length > 0) {
                        numberFacetfunction++;
                    }
                    return numberFacetfunction;
                }
            )
        }
        return numberFacetfunction;
    }

    function getShowMore() {
        return (
            <div
                className="viewall-facet-btn moreless-viewall"
                onClick={() => {
                    setShow(true)
                }}
            >
                View More
            </div>
        );
    }
    function formatNumberWithCommas (number :any) {
        return Number(Number(number).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    function getShowLess() {
        return (
            <div
                className="viewless-facet-btn moreless-viewall"
                onClick={() => {
                    setShow(false);
                }}
            >
                Less
            </div>
        );
    }

    function accordionAllFacet() {
        const morelessBtn = document.querySelectorAll(".moreless-viewall");
        // const facetContainer = document.getElementsByClassName("facet-container");
        if (checkviewmore() > (isAffiliate ? 7 : (type === pillId.PRODUCT ? 7 : (type === pillId.LEARNING ? 6 : 5)))) {
            morelessBtn?.forEach((item) => {
                item.classList.remove("disabled");
            })
        } else {
            morelessBtn?.forEach((item) => {
                item.classList.add("disabled");
            })
        }
    };

    /**
     * TODO : render list Facet
     * @param type : render with match number type pill
     * @returns
     */
    function renderFacet() {
        if (type === pillId.PRODUCT) {
            return (
                <div>
                    <div className="facet-container">
                        <CheckboxPrice title="Price" optionField="final_price" field="price" isAffiliate={false}
                                       pillBusinessSelected={props.pillBusinessSelected}
                                       pillConsumerSelected={props.pillConsumerSelected}
                                       pillProSelected={props.pillProSelected} facetDeSelect={props.controller}
                                       controller={props.controller.PriceRangeProduct} engine={headlessEngine}
                                       valueStart={4} valueEnd={6}
                                       format={(bytes: any) => `$${formatNumberWithCommas(bytes)}`}/>
                        <Checkbox title="Customer Type" controller={facetCustomerType}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        {
                            facetProductArrays.map((facetProductArray: any) => {
                                return facetProductArray.facet.state.values?.length > 0 && facetProductArray.render;
                            })
                        }
                    </div>
                </div>
            );
        } else if (type === pillId.SUPPORT) {
            return (
                <div>
                    <div className="facet-container">
                        {/* <DateFacet title="Date" field="sysdate" delimiter="/" pillBusinessSelected={props.pillBusinessSelected} pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected} facetDeSelect={props.controller} controller={props.controller.facetDate} /> */}
                        {!props.isActiveINET && (
                            <Checkbox title="Customer Type" controller={facetCustomerType}
                                      pillBusinessSelected={props.pillBusinessSelected}
                                      pillConsumerSelected={props.pillConsumerSelected}
                                      pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        )}
                        <Checkbox title="Content Source" controller={props.controller.facetContentSource}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Issue Type" controller={props.controller.facetContentSourceSalesforce}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Operating System" controller={props.controller.facetOperatingSystemSalesforce}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        {props.isShowRecommendedForModel !== undefined && (<CheckboxRecommended title="Type" controller={props.controller.facetFileType}
                                   pillBusinessSelected={props.pillBusinessSelected}
                                   pillConsumerSelected={props.pillConsumerSelected}
                                   pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>)}
                        <DateFacet2 title="Date" field="date" delimiter="/"
                                    startDateController={props.controller.facetFileStartDate}
                                    endDateController={props.controller.facetFileEndDate}
                                    pillBusinessSelected={props.pillBusinessSelected}
                                    pillConsumerSelected={props.pillConsumerSelected}
                                    pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Language" controller={props.controller.facetFileLanguage}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Content Type" controller={props.controller.facetSourceSalesforce}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                    </div>
                </div>
            );
        } else if (type === pillId.INDUSTRIES) {
            return (
                <div>
                    <div className="facet-container">
                        <Checkbox title="Customer Type" controller={facetCustomerType}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Type" controller={props.controller.facetIndustry}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Product type" controller={props.controller.facetProductType}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                    </div>
                </div>
            );
        } else if (type === pillId.INSPIRATION) {
            return (
                <div>
                    <div className="facet-container">
                        <Checkbox title="Customer Type" controller={facetCustomerType}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Topic" controller={props.controller.facetTopic}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Product type" controller={props.controller.facetProductType}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <Checkbox title="Author" controller={props.controller.facetAuthor}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                    </div>
                </div>
            );
        } else if (type === pillId.LEARNING) {
            console.log("Facet.pillId.LEARNING")
            console.log(props.controller)
            return (
                <div>
                    <div className="facet-container">
                        {/*<DateFacet title="Date" field="sysdate" delimiter="/" controller={props.controller.facetDate} pillBusinessSelected={props.pillBusinessSelected} pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected} facetDeSelect={props.controller} />*/}
                        <DateFacet2 title="Date" field="sysdate" delimiter="/"
                                    startDateController={props.controller.filterStartDate}
                                    endDateController={props.controller.filterEndDate}
                                    pillBusinessSelected={props.pillBusinessSelected}
                                    pillConsumerSelected={props.pillConsumerSelected}
                                    pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <CheckboxPrice title="Price" optionField="aem_price" field="" isAffiliate={false}
                                       pillBusinessSelected={props.pillBusinessSelected}
                                       pillConsumerSelected={props.pillConsumerSelected}
                                       pillProSelected={props.pillProSelected} facetDeSelect={props.controller}
                                       controller={AEMPriceRange} engine={headlessEngine} valueStart={4} valueEnd={6}
                                       format={(bytes: any) => `$${formatNumberWithCommas(bytes)}`}/>
                        <Checkbox title="Customer Type" controller={facetCustomerType}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        {
                            facetLearningArrays.map((facetLearningArray: any) => {
                                return facetLearningArray.facet.state.values?.length > 0 && facetLearningArray.render;
                            })
                        }
                    </div>
                </div>
            );
        } else if (type === pillId.RESOURCES) {
            return (
                <div>
                    <div className="facet-container">
                        {/*<DateFacet title="Date" field="sysdate" delimiter="/" controller={props.controller.facetDate} pillBusinessSelected={props.pillBusinessSelected} pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected} facetDeSelect={props.controller} />*/}
                        <DateFacet2 title="Date" field="sysdate" delimiter="/"
                                    startDateController={props.controller.filterStartDate}
                                    endDateController={props.controller.filterEndDate}
                                    pillBusinessSelected={props.pillBusinessSelected}
                                    pillConsumerSelected={props.pillConsumerSelected}
                                    pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        <CheckboxPrice title="Price" optionField="aem_price" field="price" isAffiliate={false}
                                       pillBusinessSelected={props.pillBusinessSelected}
                                       pillConsumerSelected={props.pillConsumerSelected}
                                       pillProSelected={props.pillProSelected} facetDeSelect={props.controller}
                                       controller={AEMPriceRange} engine={headlessEngine} valueStart={4} valueEnd={6}
                                       format={(bytes: any) => `$${formatNumberWithCommas(bytes)}`}/>
                        <Checkbox title="Customer Type" controller={facetCustomerType}
                                  pillBusinessSelected={props.pillBusinessSelected}
                                  pillConsumerSelected={props.pillConsumerSelected}
                                  pillProSelected={props.pillProSelected} facetDeSelect={props.controller}/>
                        {
                            facetResourceArrays.map((facetResourceArray: any) => {
                                return facetResourceArray.facet.state.values?.length > 0 && facetResourceArray.render;
                            })
                        }
                    </div>
                </div>
            );
        } else if (type === pillId.COMMUNITY) {
            return (
                <div>
                    <div className="facet-container">
                        <Checkbox title="Type" controller={props.controller.facetType} pillBusinessSelected={props.pillBusinessSelected} pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected} facetDeSelect={props.controller} />
                        {/*<DateFacet title="Date" field="limessageposttime" startDateField="limessageposttime" endDateField="limessageposttime" delimiter="/" controller={props.controller.facetDate} pillBusinessSelected={props.pillBusinessSelected} pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected} facetDeSelect={props.controller} />*/}
                        <DateFacet2 title="Date" field="limessageposttime" delimiter="/"
                                    startDateController={props.controller.filterCommunityStartDate}
                                    endDateController={props.controller.filterCommunityEndDate}
                                    pillBusinessSelected={props.pillBusinessSelected}
                                    pillConsumerSelected={props.pillConsumerSelected} />
                        <Checkbox title="View Result by" controller={props.controller.facetAdvanceCommunity} pillBusinessSelected={props.pillBusinessSelected} pillConsumerSelected={props.pillConsumerSelected} pillProSelected={props.pillProSelected} facetDeSelect={props.controller} />
                    </div>
                </div>
            );
        }
    }

    return (
        <div className="facet-section">
            {renderFacet()}
        </div>
    );
};
